var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotemediaAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20C12.794 20 11 18.206 11 16C11 13.794 12.794 12 15 12C17.206 12 19 13.794 19 16C19 18.206 17.206 20 15 20ZM15 14C13.897 14 13 14.897 13 16C13 17.103 13.897 18 15 18C16.103 18 17 17.103 17 16C17 14.897 16.103 14 15 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H19.414L17.414 8H16V4C16 2.895 15.104 2 14 2H3C1.896 2 1 2.895 1 4V18C1 19.105 1.896 20 3 20H7V21C7 22.103 7.897 23 9 23H21C22.103 23 23 22.103 23 21V12C23 10.897 22.103 10 21 10ZM3 6H13V8H3V6ZM3 10H7V12H3V10ZM3 16V14H7V16H3ZM21 21H9V12H11.414L13.414 10H16.586L18.586 12H21V21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotemediaAdded);
export default __webpack_public_path__ + "static/media/icon-notemedia-added.0dc8c278fd4529407d2e605c4a332332.svg";
export { ForwardRef as ReactComponent };